import Vue from 'vue'
import VueRouter from 'vue-router'
import goTo from 'vuetify/es5/services/goto'
import Missing from '../views/404.vue'
import Demo from '../views/Demo.vue'


Vue.use(VueRouter)

const routes = [{
        path: '/',
        component: () =>
            import ('../views/all-home-version/MainDemoDark.vue'),
        meta: {
            title: 'Empresa de Sistemas e Aplicativos em Itajaí-SC | Codetime'
        }
    },

    // {
    //     path: '/main-demo',
    //     name: 'MainDemo',
    //     meta: {
    //         title: 'Versão Light - Codetime'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/MainDemo.vue')
    // },
    // {
    //     path: '/main-demo-dark',
    //     name: 'MainDemoDark',
    //     meta: {
    //         title: 'Versão Dark - Codetime'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/MainDemoDark.vue')
    // },
    // {
    //     path: '/creative-agency',
    //     name: 'CreativeAgency',
    //     meta: {
    //         title: 'Creative Agency - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/CreativeAgency.vue')
    // },
    // {
    //     path: '/digital-agency',
    //     name: 'DigitalAgency',
    //     meta: {
    //         title: 'Digital Agency - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/DigitalAgency.vue')
    // },
    // {
    //     path: '/business',
    //     name: 'Business',
    //     meta: {
    //         title: 'Business - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/Business.vue')
    // },
    // {
    //     path: '/corporate-business',
    //     name: 'CorporateBusiness',
    //     meta: {
    //         title: 'Corporate Business - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/CorporateBusiness.vue')
    // },
    // {
    //     path: '/startup',
    //     name: 'StartUp',
    //     meta: {
    //         title: 'Start Up - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/StartUp.vue')
    // },
    // {
    //     path: '/creative-portfolio',
    //     name: 'CreativePortfolio',
    //     meta: {
    //         title: 'Creative Portfolio - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/CreativePortfolio.vue')
    // },
    // {
    //     path: '/minimal-portfolio',
    //     name: 'MinimalPortfolio',
    //     meta: {
    //         title: 'Minimal Portfolio - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/MinimalPortfolio.vue')
    // },
    // {
    //     path: '/landing-home-particle',
    //     name: 'LandingHomeParticle',
    //     meta: {
    //         title: 'Landing Home Particle - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/LandingHomeParticle.vue')
    // },
    // {
    //     path: '/landing-creative-agency',
    //     name: 'LandingCreativeAgency',
    //     meta: {
    //         title: 'Landing Creative Agency - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/LandingCreativeAgency.vue')
    // },
    // {
    //     path: '/landing-interior',
    //     name: 'LandingInterior',
    //     meta: {
    //         title: 'Landing Interior - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/LandingInterior.vue')
    // },
    // {
    //     path: '/landing-personal-portfolio',
    //     name: 'LandingPersonalPortfolio',
    //     meta: {
    //         title: ' Personal Portfolio Landing - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/LandingPersonalPortfolio.vue')
    // },
    // {
    //     path: '/landing-dark-portfolio',
    //     name: 'LandingDarkPortfolio',
    //     meta: {
    //         title: 'Personal Portfolio Landing - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/LandingDarkPortfolio.vue')
    // },
    // {
    //     path: '/personal-portfolio',
    //     name: 'PersonalPortfolio',
    //     meta: {
    //         title: 'Personal Portfolio - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/PersonalPortfolio.vue')
    // },
    // {
    //     path: '/designer-portfolio',
    //     name: 'DesignerPortfolio',
    //     meta: {
    //         title: 'Designer Portfolio - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/DesignerPortfolio.vue')
    // },
    // {
    //     path: '/studio-agency',
    //     name: 'StudioAgency',
    //     meta: {
    //         title: 'Studio Agency - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/all-home-version/StudioAgency.vue')
    // },
    // {
    //     path: '/service',
    //     name: 'Service',
    //     meta: {
    //         title: 'Serviços de Desenvolvimento de Sistemas | Codetime Itajaí'
    //     },
    //     component: () =>
    //         import ('../views/service/Service.vue')
    // },
    // {
    //     path: '/service-details',
    //     name: 'ServiceDetails',
    //     meta: {
    //         title: 'Detalhes do Serviço - Codetime'
    //     },
    //     component: () =>
    //         import ('../views/service/ServiceDetails.vue')
    // },
    {
        path: '/servicos/desenvolvimento-aplicativos-itajai',
        name: 'DesenvolvimentoAplicativosItajai',
        meta: {
            title: 'Desenvolvimento de Aplicativos em Itajaí, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/DesenvolvimentoAplicativosItajai.vue')
    },
    {
        path: '/servicos/dashboards-bi-itajai',
        name: 'DashboardsBI',
        meta: {
            title: 'Dashboards e Business Intelligence em Itajaí, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/DashboardsBI.vue')
    },
    {
        path: '/servicos/desenvolvimento-sistemas-web-itajai',
        name: 'SistemasSobMedidaItajai',
        meta: {
            title: 'Sistemas Web e Software Sob Medida em Itajaí, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/SistemasSobMedidaItajai.vue')
    },
    {
        path: '/servicos/integracao-sistemas-api-itajai',
        name: 'IntegracoesApi',
        meta: {
            title: 'Integração de Sistemas e APIs em Itajaí, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/IntegracoesApiItajai.vue')
    },
    {
        path: '/servicos/automacao-processos-itajai',
        name: 'AutomacaoProcessos',
        meta: {
            title: 'Automação de Processos e RPA em Itajaí, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/AutomacaoProcessosItajai.vue')
    },
    {
        path: '/servicos/modernizacao-sistemas-legados-itajai',
        name: 'ModernizacaoSistemas',
        meta: {
            title: 'Modernização de Sistemas Legados e Migração para Nuvem em Itajaí, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/ModernizacaoSistemasItajai.vue')
    },
    // Rotas para Balneário Camboriú
    {
        path: '/servicos/desenvolvimento-apps-balneario-camboriu',
        name: 'DesenvolvimentoAplicativosBC',
        meta: {
            title: 'Desenvolvimento de Aplicativos em Balneário Camboriú, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/DesenvolvimentoAplicativosBC.vue')
    },
    {
        path: '/servicos/sistemas-web-balneario-camboriu',
        name: 'SistemasSobMedidaBC',
        meta: {
            title: 'Sistemas Web e Software Sob Medida em Balneário Camboriú, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/SistemasSobMedidaBC.vue')
    },
    {
        path: '/servicos/dashboards-bi-balneario-camboriu',
        name: 'DashboardsBIBC',
        meta: {
            title: 'Dashboards e Business Intelligence em Balneário Camboriú, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/DashboardsBIBC.vue')
    },
    {
        path: '/servicos/automacao-processos-balneario-camboriu',
        name: 'AutomacaoProcessosBC',
        meta: {
            title: 'Automação de Processos e RPA em Balneário Camboriú, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/AutomacaoProcessosBC.vue')
    },
    {
        path: '/servicos/integracao-sistemas-api-balneario-camboriu',
        name: 'IntegracoesApiBC',
        meta: {
            title: 'Integração de Sistemas e APIs em Balneário Camboriú, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/IntegracoesApiBC.vue')
    },
    {
        path: '/servicos/modernizacao-sistemas-legados-balneario-camboriu',
        name: 'ModernizacaoSistemasBC',
        meta: {
            title: 'Modernização de Sistemas Legados e Migração para Nuvem em Balneário Camboriú, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/ModernizacaoSistemasBC.vue')
    },
    // Rotas para Navegantes
    {
        path: '/servicos/desenvolvimento-apps-navegantes',
        name: 'DesenvolvimentoAplicativosNavegantes',
        meta: {
            title: 'Desenvolvimento de Aplicativos em Navegantes, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/DesenvolvimentoAplicativosNavegantes.vue')
    },
    {
        path: '/servicos/sistemas-web-navegantes',
        name: 'SistemasSobMedidaNavegantes',
        meta: {
            title: 'Sistemas Web e Software Sob Medida em Navegantes, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/SistemasSobMedidaNavegantes.vue')
    },
    {
        path: '/servicos/dashboards-bi-navegantes',
        name: 'DashboardsBINavegantes',
        meta: {
            title: 'Dashboards e Business Intelligence em Navegantes, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/DashboardsBINavegantes.vue')
    },
    {
        path: '/servicos/automacao-processos-navegantes',
        name: 'AutomacaoProcessosNavegantes',
        meta: {
            title: 'Automação de Processos e RPA em Navegantes, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/AutomacaoProcessosNavegantes.vue')
    },
    {
        path: '/servicos/integracao-sistemas-api-navegantes',
        name: 'IntegracoesApiNavegantes',
        meta: {
            title: 'Integração de Sistemas e APIs em Navegantes, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/IntegracoesApiNavegantes.vue')
    },
    {
        path: '/servicos/modernizacao-sistemas-legados-navegantes',
        name: 'ModernizacaoSistemasNavegantes',
        meta: {
            title: 'Modernização de Sistemas Legados e Migração para Nuvem em Navegantes, SC | Codetime Sistemas'
        },
        component: () =>
            import ('../views/paginas-seo/ModernizacaoSistemasNavegantes.vue')
    },
    {
        path: '/blog',
        name: 'Blog',
        meta: {
            title: 'Blog - Codetime'
        },
        component: () =>
            import ('../views/blog/Blog.vue')
    },
    {
        path: '/blog-details/:slug',
        name: 'BlogDetails',
        meta: {
            title: 'Blog Details - VueJS Creative Agency and Portfolio Template'
        },
        component: () =>
            import ('../views/blog/BlogDetailsDynamic.vue')
    },
    // {
    //     path: '/portfolio',
    //     name: 'Portfolio',
    //     meta: {
    //         title: 'Projetos - Codetime'
    //     },
    //     component: () =>
    //         import ('../views/portfolio/Portfolio.vue')
    // },
    {
        path: '/projeto/:id',
        name: 'PortfolioDetails',
        meta: {
            title: 'Detalhes do Projetos - Codetime'
        },
        component: () =>
            import ('../views/portfolio/PortfolioDetails.vue')
    },
    // {
    //     path: '/team',
    //     name: 'Team',
    //     meta: {
    //         title: 'Team - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/Team.vue')
    // },
    // {
    //     path: '/pricing-plan',
    //     name: 'PricingPlan',
    //     meta: {
    //         title: 'Pricing Plan - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/PricingPlan.vue')
    // },
    // {
    //     path: '/testimonial',
    //     name: 'Testimonial',
    //     meta: {
    //         title: 'Tesimonial - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/Testimonial.vue')
    // },
    // {
    //     path: '/column',
    //     name: 'Column',
    //     meta: {
    //         title: 'Column - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/Column.vue')
    // },
    // {
    //     path: '/contact-form',
    //     name: 'ContactForm',
    //     meta: {
    //         title: 'Contact Form - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/ContactForm.vue')
    // },
    // {
    //     path: '/video-popup',
    //     name: 'VideoPopup',
    //     meta: {
    //         title: 'Video Popup - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/VideoPopup.vue')
    // },
    // {
    //     path: '/brand',
    //     name: 'Brand',
    //     meta: {
    //         title: 'Brand - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/Brand.vue')
    // },
    // {
    //     path: '/counter',
    //     name: 'Counter',
    //     meta: {
    //         title: 'Counter - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/Counter.vue')
    // },
    // {
    //     path: '/contact',
    //     name: 'Contact',
    //     meta: {
    //         title: 'Contato - Empresa de Software em Itajaí-SC | Codetime'
    //     },
    //     component: () =>
    //         import ('../views/Contact.vue')
    // },
    // {
    //     path: '/gallery',
    //     name: 'Gallery',
    //     meta: {
    //         title: 'Gallery - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/Gallery.vue')
    // },
    // {
    //     path: '/progressbar',
    //     name: 'Progressbar',
    //     meta: {
    //         title: 'Progressbar - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/Progressbar.vue')
    // },
    // {
    //     path: '/button',
    //     name: 'Button',
    //     meta: {
    //         title: 'Progressbar - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/Button.vue')
    // },
    // {
    //     path: '/office-location',
    //     name: 'Office Locaiton',
    //     meta: {
    //         title: 'Office Location - VueJS Creative Agency and Portfolio Template'
    //     },
    //     component: () =>
    //         import ('../views/Map.vue')
    // },
    {
        path: '*',
        component: Missing,
        meta: {
            title: 'Página não encontrada - Codetime'
        },
    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0

        if (to.hash) {
            scrollTo = to.hash
        } else if (savedPosition) {
            scrollTo = savedPosition.y
        }

        return goTo(scrollTo)
    },
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    next()
})


export default router